export default "<p>file-input works!</p>\r\n"